export default __webpack_public_path__ + "static/media/paperclip.2ed53ccb.svg";